import styled from '@emotion/styled';
import { fadeInAnimation } from '../../animations';

const Container = styled.div<{ $index: number }>`
  position: absolute;
  left: 50%;
  right: 50%;
  top: 0;
  bottom: 0;
  opacity: 0;
  animation-name: ${fadeInAnimation};
  animation-delay: ${({ $index }) => $index * 25 + 2500}ms;
  animation-fill-mode: forwards;
  animation-duration: 25ms;
  animation-timing-function: ease-out;
`;

const Mark = styled.div`
  width: 1px;
  height: 15px;
  background-color: #c2c7d4;
`;

type Props = {
  angle: number;
  index: number;
};

export const Tick = ({ angle, index }: Props) => (
  <Container $index={index} style={{ transform: `rotate(${angle}deg)` }}>
    <Mark />
  </Container>
);
